import { render, staticRenderFns } from "./MemoArea.vue?vue&type=template&id=ebe49b2c&scoped=true&lang=pug&"
import script from "./MemoArea.vue?vue&type=script&lang=ts&"
export * from "./MemoArea.vue?vue&type=script&lang=ts&"
import style0 from "./MemoArea.vue?vue&type=style&index=0&id=ebe49b2c&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebe49b2c",
  null
  
)

export default component.exports